import { useMutation, useQueryClient } from '@tanstack/react-query';

import { locationsAssetsKey } from '@pages/Sensors/services/useLocationsAssetsQuery';

import { actionItemKey } from '@services/actionItem/useActionItemQuery';
import { actionItemsGlobalOrIdListKey } from '@services/actionItem/useActionItemsGlobalOrIdListQuery';
import { apiClient } from '@services/apiClient';

import { actionItemCommentsKey } from './useActionItemCommentsQuery';

const cancelSnoozeFn = (data) => apiClient.post(`${APP_API_URL}cancel-snooze`, data);

export const useCancelSnoozeMutation = ({ actionItemId }) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: cancelSnoozeFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [actionItemsGlobalOrIdListKey()[0]] });
      queryClient.invalidateQueries({ queryKey: actionItemKey(actionItemId) });
      queryClient.invalidateQueries({ queryKey: [locationsAssetsKey()[0]] });
      queryClient.invalidateQueries({ queryKey: actionItemCommentsKey(actionItemId) });
    },
  });
};
